import { FC } from "react";

export const CompanyLinksPage: FC = () => {
  return (
    <div>
      <h1>CompanyLinksPage (Coming soon!)</h1>
    </div>
  );
};
